// axios
/* import axios from 'axios'
axios.defaults.baseURL = 'https://form.moozistudio.com/api/'

//axios.defaults.baseURL = 'http://51.38.57.172:9002/api/'prod
// axios.defaults.baseURL = 'http://51.38.57.172:9003/api/'test
// axios.defaults.baseURL = 'http://94.23.34.54:9004/api/' prodTransvie
//baseURL: 'https://form.grouptransvie.com/api/'

axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`

export default axios.create({}) */
import axios from 'axios'
import router from 'vue-router'

const apiClient = axios.create({
  baseURL: 'https://form.grouptransvie.com/api/'
})

// === Interceptor Request ===
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`    
    }
    return config
  },
  (error) => Promise.reject(error)
)

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      localStorage.removeItem('accessToken')
      router.push(router.currentRoute.query.to || '/login')
    }
    return Promise.reject(error)
  }
)

export default apiClient

